import { defineComponent as o, openBlock as n, createBlock as r, unref as c, mergeProps as i, withCtx as p, createElementVNode as a } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconHeartDiagnostic",
  __name: "IconHeartDiagnostic",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const l = t;
    return (s, e) => (n(), r(c(m), i(l, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        a("path", {
          "fill-rule": "evenodd",
          d: "M3.75 8.62A3.75 3.75 0 0 1 7.5 4.87c.982 0 1.813.493 2.515 1.077a13 13 0 0 1 .7.634l.209.197a5 5 0 0 0 .4.342c.098.07.35.25.676.25.325 0 .578-.18.676-.25a5 5 0 0 0 .4-.342l.208-.197c.211-.2.436-.414.701-.634.702-.584 1.533-1.077 2.515-1.077a3.75 3.75 0 0 1 3.75 3.75.75.75 0 0 0 1.5 0c0-2.9-2.35-5.25-5.25-5.25-1.503 0-2.672.757-3.474 1.423a16 16 0 0 0-.8.724l-.173.164L12 5.731l-.053-.05-.173-.164a16 16 0 0 0-.8-.724C10.172 4.127 9.004 3.37 7.5 3.37a5.25 5.25 0 0 0-5.25 5.25c0 1.694.888 3.038 1.896 4.033l6.932 7.57a1.25 1.25 0 0 0 1.844 0l3.288-3.59a.75.75 0 0 0-1.106-1.013L12 19.01l-6.774-7.4-.014-.013C4.346 10.747 3.75 9.759 3.75 8.62m8.01-2.692.017-.01-.017.01m.463-.01.017.01-.017-.01",
          "clip-rule": "evenodd"
        }, null, -1),
        a("path", { d: "m11.773 12.814 1.344-2.017 3 3a1.25 1.25 0 0 0 1.767 0l1.427-1.427H21a.75.75 0 1 0 0-1.5h-1.793a1.25 1.25 0 0 0-.884.366L17 12.56l-3.038-3.038a1.25 1.25 0 0 0-1.924.19l-1.44 2.16H9a.75.75 0 0 0 0 1.5h1.732a1.25 1.25 0 0 0 1.04-.558" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
